import React, { useState, Fragment, useEffect } from 'react';
import {
    Box,
    Button,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Auth } from 'aws-amplify';
import { host, SubscriptionInfo, BillingPlans } from "../../../data";
import { billing } from '../../../services/billing';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    preLoader: {
        display: 'block',
        margin: `${theme.spacing(3)}px auto`,
    },
    buttonProgress: {
        position: 'absolute',
        marginRight: 36,
    },
}));

const ChangeDeviceStatus = ({ orgInfo, orgBilling, billingData, setBillingData, uid, newStatus, open, handleClose, setDevices }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [estNextInvoice, setEstNextInvoice] = useState("0.00");
    const [estCharge, setEstCharge] = useState("0.00");
    const [hasBillingInfo, setHasBillingInfo] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    function findSubscriptionPlanCode(subscriptionInfo) {
        var plan_code = BillingPlans[0].plan_code;
        for (var i = 0; i < BillingPlans.length; i++) {
            if (BillingPlans[i].label === subscriptionInfo) {
                plan_code = BillingPlans[i].plan_code;
                break;
            }
        }
        return plan_code;
    }

    const handleCloseStatusChange = () => {
        setIsLoading(false);
        handleClose();
    };

    const handleStatusChange = () => {
        var code = "";
        var action = newStatus === "Active" ? 'activate' : 'deactivate'
        var targetList = [];

        targetList.push({ 'uid': uid, 'code': code, 'action': action });

        setIsLoading(true);
        {
            Auth.currentAuthenticatedUser()
                .then(data => {
                    var body = JSON.stringify({
                        'devices': targetList,
                        'hasBillingInfo': hasBillingInfo
                    });
                    var requestOptions = {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body
                    };

                    fetch(host + '/orgs/' + orgInfo.orgId + '/devices/', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            if (data.error === "OK") {
                                // Update and Create Subscription
                                updateSubscription(data.deviceList);
                                setDevices(data.deviceList);
                            } else {
                                if (data.error === "error" && data.errorList.length > 0) {
                                    alert(data.errorList[0].error);
                                }
                                else {
                                    alert(data.error)
                                }
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                });
        }
    };

    const updateSubscription = async (devices) => {
        var msg = { status: 0, data: {} };
        var quantity = 1;

        try {
            if (billingData.subscriptions.length == 0 && newStatus !== "Active") {
                handleCloseStatusChange();
                throw new Error("No subscription to delete");
            }
            else if (billingData.subscriptions.length == 0 && newStatus === "Active") {
                console.log("New Subscription");

                const plan_code = findSubscriptionPlanCode(orgBilling.billing_plan);
                msg = await billing.newSubscription(
                    orgInfo.orgId,
                    plan_code,
                    orgBilling.billing_curr,
                    quantity,
                    SubscriptionInfo.total_billing_cycles);
            } else {
                quantity = newStatus === "Active" ? billingData.subscriptions[0].quantity + 1 : billingData.subscriptions[0].quantity - 1;

                console.log("Update Subscription");

                var sub = [{}];
                sub[0].quantity = quantity;
                sub[0].id = billingData.subscriptions[0].id;
                msg = await billing.updateSubscriptions(
                    orgInfo.orgId,
                    sub
                );
            }

            const { error, billing_account } = msg.data;

            if (msg.status === 404) {
                console.log(msg.status);
            }

            if (error !== 'OK' && msg.status !== 200) {
                throw new Error(error);
            }

            setBillingData(billing_account);
            handleCloseStatusChange();
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        var newCharge = 0
        var nextInvoice = 0;
        var newQty = 1;
        var l_billingPlan = BillingPlans[0];

        for (var i = 0; i < BillingPlans.length; i++) {
            if (BillingPlans[i].label === orgBilling.billing_plan) {
                l_billingPlan = BillingPlans[i];
                break;
            }
        }

        if (billingData.subscriptions.length == 0) {
            newCharge = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * newQty * 100) / 100;
            nextInvoice = newCharge;
            if (billingData.subscriptions.length > 0) {
                nextInvoice = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * (billingData.subscriptions[0].quantity + newQty) * 100) / 100;
            }
            setEstCharge(newCharge.toString());
        } else {
            newQty = newStatus === "Active" ? 1 : -1;
            if (newStatus === "Active") {
                previewSubscription();
            }
            else {
                previewSubscription();
            }

            nextInvoice = Math.round(l_billingPlan.unit_cost[orgBilling.billing_curr] * (billingData.subscriptions[0].quantity + newQty) * 100) / 100;
        }
        setEstNextInvoice(nextInvoice.toString());
    }, []);

    const previewSubscription = async () => {
        var msg = { status: 0, data: {} };

        try {
            if (billingData.subscriptions.length == 0) {
                console.log("No Subscription, cannot preview");
            } else {
                console.log("Update Subscription");
                var sub = [{}];
                sub[0].quantity = newStatus === "Active" ? billingData.subscriptions[0].quantity + 1 : billingData.subscriptions[0].quantity - 1;
                sub[0].id = billingData.subscriptions[0].id;
                msg = await billing.previewSubscription(
                    orgInfo.orgId,
                    sub
                );
            }
            console.log(msg.data);
            const { error, billing_preview } = msg.data;

            if (msg.status === 404) {
                console.log(msg.status);
            }

            if (error !== 'OK' && msg.status !== 200) {
                throw new Error(error);
            }

            setEstCharge(billing_preview[0].estimated_total);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Fragment>
            {open && <Dialog disableBackdropClick disableEscapeKeyDown open={open} onClose={handleCloseStatusChange}>
                <DialogTitle>{t("addDevice")}</DialogTitle>
                <DialogContent className={classes.root}>
                    {<Typography variant="body2" gutterBottom>
                        {newStatus === "Active" ? t("areYouSureYouWantToActivate") : t("areYouSureYouWantToDisable")} {' ' + uid}?
                    </Typography>}

                    <div className={classes.content} />
                    {<Typography variant="body2" gutterBottom >
                        <Box fontWeight="fontWeightBold" m={0}>
                            {newStatus === "Active" ? t("estimatedTotalDueNow") : t("estimatedCredit")}: {estCharge} {orgBilling.billing_curr}
                        </Box>
                    </Typography>}

                    {<Typography variant="body2" gutterBottom >
                        <Box fontWeight="fontWeightBold" m={0}>
                            {t("estimatedTotaleDueNext")} {estNextInvoice} {orgBilling.billing_curr}
                        </Box>
                    </Typography>}

                    {<Typography variant="body2" gutterBottom >
                        {t("additonalTaxesFeesCredits")}
                    </Typography>}

                    {<div className={classes.content} />}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseStatusChange} color="primary">
                        {t("cancel")}
                    </Button>
                    {<Button variant="outlined" onClick={handleStatusChange} color="primary" disabled={isLoading}>
                        {t("confirm")}
                    </Button>}
                    {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </DialogActions>
            </Dialog>}
        </Fragment>
    );
};

export default ChangeDeviceStatus;